import React from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { ChartRisk } from "@/shared/types/chart-risk";

import { LINE_CHART_MARGIN_PARAMS_PX, PRICE_BASED_ROW_ID } from "../constants";
import { ChartWrapper } from "../styled/chart-wrapper";
import { getFormatDate } from "../utils/get-format-date";
import { numberToPercent } from "../utils/number-to-percent";

enum Volatility {
  Ewma = "volatilityEwma",
  Gkv = "volatilityGkv",
  Std = "volatilityStd",
}

const labelByVolatilityType: Record<Volatility, string> = {
  [Volatility.Std]: "STD",
  [Volatility.Ewma]: "EWMA",
  [Volatility.Gkv]: "GKHV",
};

interface Props {
  data?: ChartRisk["logReturns"];
}

export const DifferentVolatilityChart: React.FC<Props> = ({ data }) => {
  return (
    <ChartWrapper>
      <ResponsiveContainer>
        <LineChart
          data={data}
          syncId={PRICE_BASED_ROW_ID}
          margin={LINE_CHART_MARGIN_PARAMS_PX}
        >
          <YAxis tickFormatter={numberToPercent} />
          <XAxis dataKey="timestamp" tickFormatter={getFormatDate(true)} />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip
            labelFormatter={getFormatDate()}
            formatter={(value, name: Volatility) => {
              return [
                typeof value === "number" && numberToPercent(value),
                labelByVolatilityType[name],
              ];
            }}
          />
          <Line
            type="monotone"
            dataKey={Volatility.Std}
            stroke="#4faf4e"
            dot={<span />}
          />
          <Line
            type="monotone"
            dataKey={Volatility.Ewma}
            stroke="#ff8b30"
            dot={<span />}
          />
          <Line
            type="monotone"
            dataKey={Volatility.Gkv}
            stroke="#3e86be"
            dot={<span />}
          />
          <Legend
            formatter={(value: Volatility) => labelByVolatilityType[value]}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartWrapper>
  );
};
